import { render, staticRenderFns } from "./VldSchemeBackup.vue?vue&type=template&id=48053dcc&scoped=true&"
import script from "./VldSchemeBackup.vue?vue&type=script&lang=js&"
export * from "./VldSchemeBackup.vue?vue&type=script&lang=js&"
import style0 from "./VldSchemeBackup.vue?vue&type=style&index=0&id=48053dcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48053dcc",
  null
  
)

export default component.exports